import { ReactComponent as ActionDownloadIcon } from '@ui/assets/icons/action-download.svg';
import { lazy } from 'react';

import { ReactComponent as BoostIcon } from '@src/assets/icons/boost-rocket.svg';
import { ReactComponent as GenCopyIcon } from '@src/assets/icons/gen-copy.svg';
import { ReactComponent as SeasonSummaryIcon } from '@src/assets/icons/season-summary.svg';
import type { AppPage } from '@src/types';

const HomePage = lazy(() => import('@src/pages/Home'));

const BoostReportArchivePage = lazy(() => import('@ocula/boost-dash/src/Products/BoostInsights/ReportArchive'));

const BoostHome = lazy(() => import('@ocula/boost-dash/src/Products/BoostInsights/Home/BoostHomeContainer'));

const BoostCategoryDashboard = lazy(
  () => import('@ocula/boost-dash/src/Products/BoostInsights/Content/BoostContentContainer'),
);

const BoostCategoryPage = lazy(
  () => import('@ocula/boost-dash/src/Products/BoostInsights/Content/Dashboard/PageDetails/PageDetails'),
);

const GenerativeCollections = lazy(
  () => import('@ocula/boost-dash/src/Products/GenerativeCopy/Collections/PageCollections'),
);

const ContentGenerativeCollection = lazy(
  () => import('@ocula/boost-dash/src/Products/GenerativeCopy/Collections/Collection/Collection'),
);

const SeasonSummaryPage = lazy(() => import('@src/pages/PriceOptimisation/SeasonSummary'));

const Artefacts = lazy(() => import('@ocula/artefacts/src/Pages/Artefacts'));

const ApiSpec = lazy(() => import('@ocula/boost-dash/src/Products/BoostInsights/Docs/ApiSpec'));

export const appPages: readonly AppPage[] = [
  {
    path: '/',
    element: HomePage,
  },
  {
    path: '/boost',
    element: BoostHome,
    navigationConfig: {
      sectionId: 'boost',
      label: 'Insights',
      icon: <BoostIcon />,
    },
  },
  {
    path: '/boost/reportArchive',
    element: BoostReportArchivePage,
  },
  {
    path: '/boost/content/:categoryId',
    element: BoostCategoryDashboard,
  },
  { path: '/boost/content/:categoryId/pages/:pageId', element: BoostCategoryPage },
  {
    path: '/generative/collections',
    element: GenerativeCollections,
    navigationConfig: {
      sectionId: 'boost',
      label: 'Content Generation',
      icon: <GenCopyIcon />,
    },
  },
  {
    path: '/generative/collections/:collectionId/pages',
    element: ContentGenerativeCollection,
  },
  {
    path: '/price-optimisation/dynamic/season',
    element: SeasonSummaryPage,
    navigationConfig: {
      sectionId: 'priceOptimisation',
      label: 'Season',
      icon: <SeasonSummaryIcon />,
    },
  },
  {
    path: '/:module/downloads',
    element: Artefacts,
    navigationConfig: {
      sectionId: 'priceOptimisation',
      label: 'Downloads',
      icon: <ActionDownloadIcon />,
      // Note: this will need expanding to add links to other modules.
      pathOverride: '/price-optimisation/downloads',
    },
  },
  {
    path: '/docs/api-spec',
    element: ApiSpec,
  },
];
